import { CommunicationOverview, CommunicationTrendPoint, TimePatternPoint } from '@app/core/api/communication-analytics';

export interface CommunicationAnalyticsState {
  overview: CommunicationOverview | null;
  trend: CommunicationTrendPoint[];
  timePattern: TimePatternPoint[];
  loading: boolean;
  error: string | null;
}

export const initialCommunicationAnalyticsState: CommunicationAnalyticsState = {
  overview: null,
  trend: [],
  timePattern: [],
  loading: false,
  error: null
};
